const { wrapPageElement } = require('./dist/plugin/wrapPageElement');
exports.wrapPageElement = wrapPageElement;
